import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';

// You might be thinking, "why not just use the hook"?
// This component can be used conditionally, and a hook cannot.
// If I put the hook in the error boundary unconditionally, I'd change all pages to have a bone background, and that would be bad
export function BoneBackground() {
  useBoneBackgroundColor();
  return null;
}
